<template>
    <div class="form-template">
        <form class="form form-vertical">
            <div class="vx-row mb-base">
                <div :class="colClass">
                    <div class="mb-4">
                        <vs-input class="w-full" label="Asunto" name="fname"
                            placeholder="Ingresar asunto: ¡Tus inversiones están brillando!" v-model.lazy="form.subject"
                            @input="updateForm" />
                    </div>
                </div>
                <div :class="colClass">
                    <div class="mb-4">
                        <vs-input class="w-full" label="Preview" name="fname"
                            placeholder="(Opcional)" v-model.lazy="form.preview"
                            @input="updateForm" />
                    </div>
                </div>
                <div :class="colClass" class="mt-base">
                    <vs-checkbox v-model="form.greetings">¿Necesita saludo? SI/NO, por default SI</vs-checkbox>
                </div>
                <div :class="colClass">
                    <div class="mb-4">
                        <vs-input class="w-full" label="Call to action" name="fbuttontext"
                            placeholder="Ingresar texto: Ir a red girasol"
                            v-model.lazy="form.buttonText" @input="updateForm" />
                    </div>
                </div>
                <div :class="colClass">
                    <div class="mb-4">
                        <vs-input class="w-full" label="URL" name="fbuttonurl"
                            placeholder="Ingresar url: https://www.redgirasol.com/" v-model.lazy="form.buttonHref"
                            @input="updateForm" />
                    </div>
                </div>
                <div :class="colClass">
                    <div class="mb-4">
                        <label class="vs-input--label">Footer</label>
                        <v-select
                            multiple
                            label="text"
                            class="vs-custom w-full mb-5"
                            v-model.lazy="form.footer"
                            :options="footerOptions"
                            :reduce="text => text.value"
                            :clearable="false"
                            :searchable="true"
                            placeholder="Seleccione una opción"
                        ></v-select>
                    </div>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-full md:w-2/3 lg:w-2/3">
                    <div class="mb-10">
                        <label class="form-label" for="body">Cuerpo del correo</label>
                        <editor 
                            api-key="mnc357153cot398gkccou2cq1ers4zl1mhxnli57mkj6bvp7" 
                            :init="{
                                height: 350, 
                                menubar: true,  
                                toolbar: true,
                            }" 
                            :plugins="'link'"
                            output-format="html"
                            v-model.lazy="form.body"
                            @input="updateForm" />
                    </div>
                </div>
                <div class="vx-col sm:w-full md:w-1/3 lg:w-1/3">
                    <div class="mb-10">
                        <label class="form-label" for="button-href">Imagen cabecera <strong>(640px a 1024px de ancho, tamaño recomendado)</strong></label>
                        <document-upload-lite style="margin:0px !important; width:100% !important;"
                            :accepts="['png','jpg','jpeg']" upload-type="img" name="Imagen cabecera" :view-url="viewUrl()"
                            :upload-url="uploadUrl()" :check-url="viewUrl()" @on-success="onSuccessEvent" />
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import Editor from '@tinymce/tinymce-vue'
    import DocumentUploadLite from "@components/misc/DocumentUploadLite";

    const footerOptions = [
        { value: "cat_footer", text: "CAT" },
        // { value: "gat_footer", text: "GAT" },
        { value: "no_returns_footer", text: "Sin garantía de rendimientos" },
        // { value: "rg_regulated", text: "RedGirasol empresa regulada" },
    ];

    export default {
        name: 'MoldForm1',
        components: {
            'editor': Editor,
            DocumentUploadLite,
        },
        props: {
            value: {
                type: Object
            },
        },
        data: () => ({
            colClass: "vx-col sm:w-full md:w-1/2 lg:w-1/3",
            form: {
                headerImg: 'https://i0.wp.com/elfutbolito.mx/wp-content/uploads/2019/04/image-not-found.png',
                subject: '',
                body: '',
                buttonText: '',
                buttonHref: '',
                footer: [],
                greetings: true
            },
            formToJson: '',
            footerOptions: footerOptions
        }),
        mounted() {
            if (Object.keys(this.value).length > 0) {
                this.form = this.value;
            }
            this.updateForm();
        },
        methods: {
            updateForm() {
                this.formToJson = JSON.stringify(this.form);
                this.$emit("input", this.form);
            },
            uploadUrl() {
                return `upload_templates/uno`;
            },
            viewUrl() {
                return `view_templates?path=${this.form.headerImg}`;
            },
            onSuccessEvent(res) {
                this.form.headerImg = res.fullPath;
                this.updateForm();
            },
        },
    }
</script>

<style>
    form {
        margin-bottom: 0;
    }

    .form-template {
        margin: 25px 0 0 0;
    }

    .tox-notifications-container {
        display: none;
    }
</style>